import {
    BELL_BUTTON_HEIGHT_MULTIPLIER,
    CART_BUTTON_HEIGHT_MULTIPLIER,
    CART_ICON_CONTAINER_PADDING_MULTIPLIER,
    CART_ICON_MARGIN_MULTIPLIER,
    CURSOR_Z_INDEX,
    NOTIFICATION_DIALOG_MARGIN_MULTIPLIER,
    USER_PROFILE_AVATAR_LENGTH_MULTIPLIER,
    USER_PROFILE_DIALOG_RIGHT_CONTRACTED_MULTIPLIER,
} from '../constants/generalConstants';

interface ResolveSoundButtonRightOffsetArgs {
    userProfileDialogVisible: boolean,
    userLoaded: boolean,
    isRecognizedUser: boolean,
    userProfileDialogExpanded: boolean,
    notificationDialogExpanded: boolean,
}

const SOUND_BUTTON_COLLAPSED_GAP_MULTIPLIER = 1;
const SOUND_BUTTON_EXPANDED_GAP_MULTIPLIER = 1.25;
const SOUND_BUTTON_BASE_Z_INDEX = CURSOR_Z_INDEX - 2;
const SOUND_BUTTON_PRIORITY_Z_INDEX = CURSOR_Z_INDEX - 1;
const ANONYMOUS_PROFILE_STACK_WIDTH_MULTIPLIER = (
    USER_PROFILE_AVATAR_LENGTH_MULTIPLIER
    + CART_BUTTON_HEIGHT_MULTIPLIER
    + 2 * CART_ICON_CONTAINER_PADDING_MULTIPLIER
    + CART_ICON_MARGIN_MULTIPLIER
);
const RECOGNIZED_PROFILE_STACK_WIDTH_MULTIPLIER = (
    2 * NOTIFICATION_DIALOG_MARGIN_MULTIPLIER
    + BELL_BUTTON_HEIGHT_MULTIPLIER
    + 2 * USER_PROFILE_DIALOG_RIGHT_CONTRACTED_MULTIPLIER
    + USER_PROFILE_AVATAR_LENGTH_MULTIPLIER
    + CART_BUTTON_HEIGHT_MULTIPLIER
    + 2 * CART_ICON_CONTAINER_PADDING_MULTIPLIER
    + CART_ICON_MARGIN_MULTIPLIER
);
const CART_ONLY_STACK_WIDTH_MULTIPLIER = (
    CART_BUTTON_HEIGHT_MULTIPLIER
    + CART_ICON_MARGIN_MULTIPLIER
);

export default function resolveSoundButtonRightOffset({
    userProfileDialogVisible,
    userLoaded,
    isRecognizedUser,
    userProfileDialogExpanded,
    notificationDialogExpanded,
}: ResolveSoundButtonRightOffsetArgs): string {
    if (userProfileDialogVisible && isRecognizedUser) {
        return `${RECOGNIZED_PROFILE_STACK_WIDTH_MULTIPLIER}em`;
    }

    if (
        userProfileDialogVisible
        && !userLoaded
        && !(userProfileDialogExpanded || notificationDialogExpanded)
    ) {
        return `${CART_ONLY_STACK_WIDTH_MULTIPLIER + SOUND_BUTTON_COLLAPSED_GAP_MULTIPLIER}em`;
    }

    if (userProfileDialogVisible && !isRecognizedUser) {
        const gapMultiplier = (
            userProfileDialogExpanded || notificationDialogExpanded
        )
            ? SOUND_BUTTON_EXPANDED_GAP_MULTIPLIER
            : SOUND_BUTTON_COLLAPSED_GAP_MULTIPLIER;

        return `${ANONYMOUS_PROFILE_STACK_WIDTH_MULTIPLIER + gapMultiplier}em`;
    }

    return `${CART_ONLY_STACK_WIDTH_MULTIPLIER + SOUND_BUTTON_COLLAPSED_GAP_MULTIPLIER}em`;
}

export function resolveSoundButtonZIndex({
    userProfileDialogVisible,
    isRecognizedUser,
    userProfileDialogExpanded,
    notificationDialogExpanded,
}: Pick<
    ResolveSoundButtonRightOffsetArgs,
    'userProfileDialogVisible'
    | 'isRecognizedUser'
    | 'userProfileDialogExpanded'
    | 'notificationDialogExpanded'
>): number {
    if (
        userProfileDialogVisible
        && !isRecognizedUser
        && !(userProfileDialogExpanded || notificationDialogExpanded)
    ) {
        return SOUND_BUTTON_PRIORITY_Z_INDEX;
    }

    return SOUND_BUTTON_BASE_Z_INDEX;
}
